import Parse from "parse";

class ShopCategory extends Parse.Object {
    constructor() {
        super('ShopCategory');
    }

    getTitle() {
        return this.get('title');
    }

    setTitle(title) {
        this.set('title', title)
    }

    getSpanishTitle() {
        return this.get('spanishTitle');
    }

    setSpanishTitle(spanishTitle) {
        this.set('spanishTitle', spanishTitle);
    }

    getImageUrl() {
        return this.get("image").url()
    }

    setImageFile(file) {
        this.set("image", file);
    }

    setEnabled(enabled) {
        this.set('enabled', enabled);
    }

    static getQuery() {
        const parseQuery = new Parse.Query(ShopCategory);
        parseQuery.equalTo("enabled", true);
        parseQuery.ascending("title");
        return parseQuery;
    }
}

export default ShopCategory;